var _path, _rect, _path2, _rect2, _path3, _circle, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 123,
    viewBox: "0 0 120 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.9999 8C78.9999 8 79.0217 12.9045 80.4999 15.5C81.3908 17.0643 82.6843 16.8952 83.5 18.5C84.4892 20.4461 84.5997 22.4009 84 24.5C83 28 82 26.6665 79.5 30C78.0001 32 76.5491 39.3688 79.4999 43.5C81.9999 47 89.9695 45.1968 90.4999 50.5C90.9999 55.5 82.9999 63.5 81.9999 67C81.2489 69.6285 81.9999 72.5 81.9999 72.5",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 110,
    width: 27,
    height: 11,
    rx: 2,
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 103.5C67.5 103.5 69 96 71.5 94C74.8129 91.3496 79.4351 90.1191 84.5 87C90.5063 83.3012 97.5577 74.5879 99 75C102.5 76 88.5 91.5 89.5 92C90.5 92.5 100.531 84.7774 106 78.5C110.447 73.3958 113 61.9614 116.5 64C118 64.8737 117.758 73.412 116 79C114.553 83.6004 112.5 86.5 109 90C102.29 96.7103 89.5 104 89.5 104",
    stroke: "#6ECDA9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 27,
    height: 11,
    rx: 2,
    transform: "matrix(-1 0 0 1 54.4874 108)",
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9874 103.5C52.9874 103.5 51.4874 96 48.9874 94C45.6744 91.3496 41.0523 90.1191 35.9874 87C29.9811 83.3012 22.9297 74.5879 21.4874 75C17.9874 76 31.9874 91.5 30.9874 92C29.9874 92.5 19.9564 84.7774 14.4874 78.5C10.0404 73.3958 7.4874 61.9614 3.9874 64C2.4874 64.8737 2.72988 73.412 4.4874 79C5.93431 83.6004 7.9874 86.5 11.4874 90C18.1977 96.7103 30.9874 104 30.9874 104",
    stroke: "#6ECDA9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 42,
    r: 39.5,
    stroke: "#6ECDA9",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69 5C69 5 67.4133 8.9748 65 11.5C60.6808 16.0194 54 13.5 49 17C44.9913 19.8061 46 27 43 28C40.4456 28.8515 40.5 21 37 21C34.9243 21 32.5717 23.1435 33.5 25C35 28 32.8591 30.3766 34 33.5C35.564 37.7817 37.6755 40.0585 42 41.5C45 42.5 47.8537 40.752 51 42.5C54.6 44.5 56.2304 50.4588 61 54.5C64.6794 57.6176 69 55.5 71.5 61C72.555 63.321 70.4417 67.3079 67.5 69.5C65.8728 70.7125 60.5956 70.9522 58.5 72C55.5 73.5 50.5 79 50.5 79",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35C22 35 33.1364 40.2729 36 46C38 50 34.8533 51.9864 36 56C37 59.5 42.1209 62.967 42.5 66C43 70 41 75 41 75",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.41115857a701a2b804c4feef0742b8db.svg";
export { ForwardRef as ReactComponent };